import { render, staticRenderFns } from "./NumberBox.vue?vue&type=template&id=7ac765c8&"
import script from "./NumberBox.vue?vue&type=script&lang=js&"
export * from "./NumberBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports